<template>
  <div class="page">
    <div
      class="one"
      v-for="item in videoList"
      :key="item.huoId"
      @click="toDetail(item.huoId)"
    >
      <img :src="item.cover" alt="#" />
      <div class="text">
        <div class="longName">{{ item.longName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoList: []
    };
  },
  methods: {
    init() {
      let url =
        process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_URL2 + "shipin/shipin.json"
          : "/agent/shipin/shipin.json";
      this.axios
        .get(url, {
          headers: {
            Expires: "0",
            Pragma: "no-cache",
            "Cache-Control": "no-cache, no-store, max-age=0"
          }
        })
        .then(res => {
          if (res.status == 200) {
            let { shipinPage } = res.data.data;
            if (shipinPage && JSON.stringify(shipinPage) != "[]") {
              this.videoList = shipinPage[0].content;
            }
          }
        });
    },
    toDetail() {
      // this.$router.push({
      //   path: "/shipin/detail",
      //   query: { id: id }
      // });
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .one {
    width: 216px;
    margin: 20px 29px 1px 1px;
    float: left;
    position: relative;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;
    background: #fff;
    img {
      width: 216px;
      height: 216px;
      border-radius: 8px 8px 0 0;
    }
    .text {
      width: 216px;
      height: 66px;
      line-height: 28px;
      padding: 5px 8px;
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      border-radius: 0 0 8px 8px;
    }
  }
  .one:nth-child(5n + 0) {
    margin-right: 0;
    margin-left: 0;
  }
  .one:hover::after {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 2, 4, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
    content: "";
  }
}
</style>
